import styled from 'styled-components';
import { colors } from 'Constants/Colors';
import { palette } from 'Constants/Palette';
import { GRID_INSET } from './components/organisms/CoursesCardGrid/CoursesCardGrid.styled';

export const CourseSection = styled.section`
  & + & {
    margin-top: 28px;
  }
`;

// Misma estética que el Edcap del Dashboard, sin importar cruzado entre páginas.
// padding-left: comparte GRID_INSET con ListMyCourses para que el título arranque en el
// mismo borde que las cards; no es un número mágico aparte.
export const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${palette.muted};
  padding-left: ${GRID_INSET};
`;

export const ErrorState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 3rem 1rem;
`;

export const RetryButton = styled.button`
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1.5rem;
  background: ${colors.GREEN};
  color: ${colors.WHITE};
  cursor: pointer;
`;
